import React, {Component} from 'react';
import {connect} from 'react-redux';

import BreedWeightOutput from './../../components/BreedWeightOutput/BreedWeightOutput';
import Loader from './../../components/Loader/Loader'

/**
 * Breed Weight container
 */
class BreedWeight extends Component {
  render() {
    const {readyBreed, selectedBreedData} = this.props;
    // If Animal type or Breed data is pending
    if(!readyBreed) return (
      <Loader/>
    );
    // Return output
    return (
      <div className='nppe2-fc-breed-weight-output__wrapper'>
        <BreedWeightOutput dataBreed={selectedBreedData}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedBreedData: state.breedReducer.selectedData,
    readyBreed: state.breedReducer.ready,
  }
};

export default connect(mapStateToProps)(BreedWeight);
